import { parseConfig } from './config_parser';
import GustoAnalytics from './gusto_analytics';
import { isBrowser } from './helpers/environment_helper';
import init from './init';
import { CookieUtils } from './types/cookies_utils';
import { MetadataUtils } from './types/metadata_utils';
import { SnowplowUtils } from './types/snowplow_utils';

// Set up config in <script> block before including GustoAnalytics in a separate <script src=...>
const config = parseConfig() || {};

let gustoAnalyticsSingleton: GustoAnalytics | null = null;

// Export initialization function for ESM consumers
export const initializeGustoAnalytics = (
  cookieUtils: CookieUtils,
  metadataUtils: MetadataUtils,
  snowplowUtils: SnowplowUtils | undefined,
  config: any,
) => {
  gustoAnalyticsSingleton = new GustoAnalytics(config, cookieUtils, metadataUtils, snowplowUtils);
  gustoAnalyticsSingleton.loadAnalytics();
  init(gustoAnalyticsSingleton, cookieUtils, metadataUtils);
  return gustoAnalyticsSingleton;
};

// init() will be called automatically unless this is a server side environment
// or config.autoInit = false
if (isBrowser && config.autoInit !== false) {
  gustoAnalyticsSingleton = new GustoAnalytics(config);
  gustoAnalyticsSingleton.loadAnalytics();
  init(gustoAnalyticsSingleton);
}

export default gustoAnalyticsSingleton;
